import baseCtls from './baseCtls/index';
import containersCtls from './containers/index';
import processCtls from './processCtls/index';

export default {
  ...processCtls,
  ...baseCtls,
  ...containersCtls,
}
